import {getFormMessages} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {RsvpInfoButton} from '../rsvp-info-button/rsvp-info-button'
import {ClosedRegistrationButtonProps} from './interfaces'

export const ClosedRegistrationButton: React.FC<ClosedRegistrationButtonProps> = ({href}) => {
  const event = useAppSelector(getEvent)

  const {registrationClosed} = getFormMessages(event)

  return <RsvpInfoButton messages={registrationClosed} dataHook={DH.CLOSED_REGISTRATION} href={href} />
}
